import React, { useState, useEffect } from "react";
import {
    Layout,
    theme,
    Input,
    ConfigProvider,
    Row,
    Form,
    Typography,
    Col,
    Table,
    Select,
    Divider,
    Spin,
    Card,
    Breadcrumb,
    Collapse,
    Checkbox,
    DatePicker,
    Space,
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate, Link } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";



const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

function MainPage(props) {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [selectedBranch, setSelectedBranch] = useState ()
    const [formData, setFormData] = useState({
        assDate: "",
        branch: "",
        fromLoanOfficer: "",
        toLoanOfficer:""

    })




    useEffect(() => {
        // Simulate an API call or data fetching
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    function onCancel() {
        navigate("/dashboard", { replace: false });
    }

    const onSubmit = (values) => {
        console.log("Success:", values);
        setFormData(values)
    };

   const onSelectedOffice = (value) => {
      setFormData({...formData, branch: value})
   }


    return (
        <div>
            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                    marginBottom: 25,
                }}>
                <Col>
                    <Row style={{ marginBottom: 0, marginTop: 0 }}>
                        <Title level={2} style={{ margin: 0 }}>
                            {props.titleOfPage}
                        </Title>
                    </Row>
                    <Breadcrumb style={{ marginBottom: 0 }}>
                        <BreadcrumbItem>
                            <Link to="/dashboard">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Text>Bulk Loan Reassignment</Text>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Col>

            </Card>
            <div>
                <Spin spinning={loading}>
                    <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>

                        <Card
                            style={{
                                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                                borderRadius: 20,
                            }}

                            title={<Title level={4}>Bulk Loan Reassignment</Title>}
                        >
                            <Card
                                style={{
                                    marginBottom: "2%",
                                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                                }}
                            >
                                <Row>
                                    <Space size={45} align="baseline">
                                        <Form.Item
                                            name="branch"
                                            label={<Text strong>Branch</Text>}
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                        >
                                            <Select
                                                placeholder="Select Office"
                                                showSearch
                                                onChange={onSelectedOffice}
                                                style={{ width: "30vh" }} >
                                                <Select.Option value="headOffice">Head Office</Select.Option>
                                                <Select.Option value="demo">DEMO</Select.Option>
                                                <Select.Option value="testOffice">TEST_OFFICE</Select.Option>
                                                <Select.Option value="duala">DUALA</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            name="assDate"
                                            label={<Text strong>Assignment Date</Text>}
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                        >
                                            <DatePicker style={{ width: "30vh" }} />
                                        </Form.Item>
                                    </Space>
                                </Row>
                                <Row>
                                    <Space size={( formData.branch === "")? 0:45} align="baseline">
                                            <Form.Item
                                                name="fromLoanOfficer"
                                                hidden={(formData.branch === "")? true: false}
                                                label={<Text strong>From loan Officer</Text>}
                                            rules={[{
                                                required: true,
                                                message: "Required Field"
                                            }]}
                                            >
                                                <Select style={{ width: "30vh" }} />
                                            </Form.Item>
                                        <Form.Item
                                            name="toLoanOfficer"
                                            label={<Text strong>To loan Officer</Text>}
                                        rules={[{
                                            required: true,
                                            message: "Required Field"
                                        }]}
                                        >
                                            <Select style={{ width: "30vh" }} />
                                        </Form.Item>
                                    </Space>
                                </Row>
                            </Card>
                            <Form.Item>
                                <Row>
                                    <CustomButton
                                        content="Submit"
                                        style={{
                                            width: "10%",
                                            marginLeft: "auto",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        }}
                                        htmlType="submit"
                                        backgroundColor="#92428B"
                                        colorText="white"
                                        hoverBackground="#AD4EA7"
                                    />
                                    <CustomButton
                                        content="Cancel"
                                        style={{
                                            width: "10%",
                                            marginLeft: "1%",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        }}
                                        backgroundColor="#fff"
                                        colorText="black"
                                        hoverBackground="#F5F5F5"
                                        onClick={onCancel}
                                    />
                                </Row>
                            </Form.Item>
                        </Card>
                    </Form>
                </Spin>
            </div>
        </div >
    )
}


const SYA2400 = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState("/cst0100");
    const [switchLabel, setSwitchLabel] = useState("Dark Mode");
    const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
    const [menuBG, setMenuBG] = useState("#2F172D");
    const [searchColorBgContainer, setSearchColorBgContainer] =
        useState("#3B2639");
    const [menuTheme, setMenuTheme] = useState("dark");
    const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
    const [logoDimensions, setLogoDimensions] = useState(100);
    const [menuSearchBarState, setMenuSearchBarState] = useState(false);
    const [menuSearchIconState, setMenuSearchIconState] = useState(true);
    const [switchLabelState, setSwitchLabelState] = useState(false);

    function onSwitchClick() {
        if (switchLabel === "Dark Mode") {
            setSwitchLabel("Light Mode");
            setMenuBG("#fff");
            setSearchColorBgContainer("#f7f8fa");
            setSwitchLabelColor("#8c8f9f");
            setMenuTheme("light");
        } else {
            setSwitchLabelColor("#aeaeae");
            setSwitchLabel("Dark Mode");
            setMenuBG("#2F172D");
            setSearchColorBgContainer("#3B2639");
            setMenuTheme("dark");
        }
    }

    function onMenuSelect(menuItems) {
        // console.log(menuItems.key);
        setSelectedKey(menuItems.key);
        navigate(menuItems.key, { replace: false });
    }

    useEffect(() => {
        if (collapsed === true) {
            setLeftLayoutMargin(71);
            setLogoDimensions(50);
            setMenuSearchBarState(true);
            setMenuSearchIconState(false);
            setSwitchLabelState(true);
        } else {
            setLeftLayoutMargin(190);
            setLogoDimensions(100);
            setMenuSearchBarState(false);
            setMenuSearchIconState(true);
            setSwitchLabelState(false);
        }
    });

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                components: {
                    Layout: {
                        siderBg: menuBG,
                    },
                    Menu: {
                        darkItemBg: menuBG,
                        darkSubMenuItemBg: "#241223",
                    },
                },
            }}
        >
            <MainLayout
                collapsed={collapsed}
                searchColorBgContainer={searchColorBgContainer}
                theme={menuTheme}
                defaultSelectedKeys={selectedKey}
                items={menuItems}
                onClick={onMenuSelect}
                switchLabel={switchLabel}
                onSwitchClick={onSwitchClick}
                switchLabelColor={switchLabelColor}
                logoDimensions={logoDimensions}
                menuSearchBarState={menuSearchBarState}
                menuSearchIconState={menuSearchIconState}
                switchLabelState={switchLabelState}
                setCollapsed={setCollapsed}
                leftLayoutMargin={leftLayoutMargin}
                colorBgContainer={colorBgContainer}
            >
                <MainPage titleOfPage={"Bulk Loan Reassignment"} />
            </MainLayout>
        </ConfigProvider>
    );
};
export default SYA2400;
